import { useEffect } from "react";

export const Toast = ({ message, type, onClose }) => {
  useEffect(() => { const t = setTimeout(onClose, 3000); return () => clearTimeout(t); }, [onClose]);
  return <div className={`toast toast-${type}`}>{message}</div>;
};

export const GameBadge = ({ game }) => (
  <span className={`detail-badge ${game === "pokemon" ? "badge-pokemon" : "badge-onepiece"}`}>
    {game === "pokemon" ? "Pokémon" : "One Piece"}
  </span>
);

export const CardImage = ({ card, className = "card-thumb", placeholderClass = "card-thumb-placeholder" }) => {
  if (!card) return <div className={placeholderClass}>?</div>;
  if (card.image_url) {
    return (
      <img
        src={card.image_small || card.image_url}
        alt={card.name}
        className={className}
        loading="lazy"
        onError={(e) => { e.target.style.display = "none"; }}
      />
    );
  }
  return (
    <div className={placeholderClass}>
      <span className="game-icon">{card.game === "pokemon" ? "⚡" : "🏴‍☠️"}</span>
      <span className="card-num">{card.card_number}</span>
    </div>
  );
};

export const fmt = (n) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n);
export const fmtPct = (n) => (n >= 0 ? "+" : "") + (n * 100).toFixed(1) + "%";
export const fmtDate = (d) => new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });

/**
 * Format price converted to user's selected currency
 * @param {number} amountUSD - price in USD
 * @param {string} currencyCode - target currency code
 * @param {object} rates - exchange rates object {BRL: 5.7, EUR: 0.92, ...}
 */
export const fmtPrice = (amountUSD, currencyCode = "USD", rates = {}) => {
  if (amountUSD === 0 || amountUSD == null) return "—";
  const rate = rates[currencyCode] || 1;
  const converted = amountUSD * rate;
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currencyCode,
      minimumFractionDigits: currencyCode === "JPY" || currencyCode === "KRW" ? 0 : 2,
      maximumFractionDigits: currencyCode === "JPY" || currencyCode === "KRW" ? 0 : 2,
    }).format(converted);
  } catch {
    return `${converted.toFixed(2)} ${currencyCode}`;
  }
};
